<template>
  <router-view />
</template>

<script>
export default {
  // setup() {
    // window.addEventListener('beforeunload', (event) => {
      // localStorage.clear()
      // event.preventDefault();
    // });
  // }
};
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
}
</style>
